import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRightIcon } from 'lucide-react';
import { trackAddToCart } from '../utils/metaPixel';
const CTA_LINK = 'https://www.mareaa.online/cart/53202441404781:1';
export function FinalCTA() {
  return <section className="w-full bg-gradient-to-br from-primary via-primary-mid to-primary py-16 px-4 md:px-8" data-id="element-65">
      <div className="max-w-2xl mx-auto text-center text-white" data-id="element-66">
        <motion.div initial={{
        opacity: 0,
        y: 25
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-67">
          <p className="text-white/60 text-sm uppercase tracking-wider mb-4" data-id="element-68">
            🏁 Última oportunidad
          </p>

          <h2 className="text-2xl md:text-3xl lg:text-4xl font-serif mb-4 text-white" data-id="element-69">
            Hoy podés seguir sintiéndote igual…
          </h2>

          <p className="text-xl font-semibold mb-6 text-white" data-id="element-70">
            o empezar a sentirte liviana, menos hinchada y cómoda con tu cuerpo.
          </p>

          <p className="text-white/70 mb-2" data-id="element-71">Tu cuerpo no está en tu contra.</p>
          <p className="text-white font-semibold text-lg mb-8" data-id="element-72">
            👉 Solo necesita el enfoque correcto.
          </p>

          <motion.a href={CTA_LINK} onClick={trackAddToCart} whileHover={{
          scale: 1.03
        }} whileTap={{
          scale: 0.97
        }} className="inline-flex items-center gap-3 bg-accent hover:bg-accent/90 text-white font-bold text-base md:text-lg px-10 py-5 rounded-full shadow-2xl shadow-accent/30 transition-all duration-300" data-id="element-73">
            SÍ, QUIERO EMPEZAR HOY Y DESINFLAMAR MI ABDOMEN
            <ArrowRightIcon className="w-5 h-5" data-id="element-74" />
          </motion.a>

          <p className="text-white/50 text-xs mt-4" data-id="element-75">
            Acceso inmediato · Guía completa · Bonos incluidos · Garantía de 7
            días
          </p>

          <div className="mt-10 pt-6 border-t border-white/15" data-id="element-76">
            <p className="text-xs text-white/40" data-id="element-77">
              © 2025 Cero Inflamación. Todos los derechos reservados.
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}